module.exports = __webpack_public_path__ + "components/flag/static/square/pt-9d53365dda592195b274313c2345128d.svg";